
import { RootState } from "@/store";
import { addCurrentThemeClassToEle } from "@/utils";
import { useSelector } from "react-redux";

export default function CertificateView(props: any) {
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);
    
    return (
        <div className={`certificateViewMain timelineSectionsCommonPaddingLeft ${addCurrentThemeClassToEle(currentTheme, 'certificateViewMain')}`}>
            {props.ui}
        </div>
    );
};

